import FlowConfigBase from '#client/config/FlowConfigBase';
import AUTH_POLICY from '#client/constants/authPolicy';
import * as ROUTES from '#client/constants/routes';

import PAGES, { PAGE_KEYS } from '../flowPageConfig';

export default FlowConfigBase.createEntry({
  id: 'corp-addons',
  pageKeys: [
    PAGE_KEYS.CONFIRMATION,
    PAGE_KEYS.BUSINESS_LICENSE_REPORT,
    PAGE_KEYS.DOMAIN_NAME_REGISTRATION,
    PAGE_KEYS.WEBSITE_BUILDER,
    PAGE_KEYS.CHECKOUT,
    PAGE_KEYS.CONCLUSION
  ],
  pageConfigs: {
    [PAGES.CHECKOUT.pageComponent]: {
      pageComponentProps: {
        slotProps: {
          businessCardProps: {
            businessInfoFields: { disableBusinessName: true }
          },
          listCallout: {
            showFilingGuarantee: false
          },
          pageHeader: {
            showSubtitle: false
          }
        }
      }
    }
  },
  autoLoadBusiness: true,
  authPolicy: AUTH_POLICY.REQUIRED,
  entityType: 'corp',
  postOrderRedirect: ROUTES.DASHBOARD,
  priceListUuids: {
    development: '2a0e3b95-84db-4fd5-ab41-685a79151393',
    production: '5aa483da-649d-4c16-9ee2-c481ff296f73'
  },
  requiredEntitlements: ['formation_corp']
});
